import Send from '../send';

const DEFAULT_API = '/v1/board-info';
export default {
    getBoardInfos(boardCategory, siteInfoSeq) {
        return Send({
            url : `${DEFAULT_API}`,
            method : 'GET',
            params : {
                boardCategory : boardCategory,
                siteInfoSeq : siteInfoSeq
            }
        });
    },

    searchBoardInfos(boardCategory, siteInfoSeq, searchInfo) {
        return Send({
            url : `${DEFAULT_API}/searchBoardInfos`,
            method : 'GET',
            params : {
                boardCategory : boardCategory,
                siteInfoSeq : siteInfoSeq,
                boardSearchType : searchInfo.boardSearchType,
                searchValue : searchInfo.searchValue
            }
        });
    },

    getSelectBoardInfo(boardInfoSeq) {
        return Send({
            url : `${DEFAULT_API}/select`,
            method : 'GET',
            params : {
                boardInfoSeq : boardInfoSeq
            }
        });
    },

    createBoardInfo(boardInfoDTO) {
        return Send({
            url : `${DEFAULT_API}`,
            method : 'POST',
            data : boardInfoDTO
        })
    },

    updateBoardInfo(boardInfoDTO) {
        return Send({
            url : `${DEFAULT_API}`,
            method : 'PUT', 
            data : boardInfoDTO
        });
    },

    deleteBoardInfo(boardInfoSeq) {
        return Send({
            url : `${DEFAULT_API}`,
            method : 'DELETE',
            params : {
                boardInfoSeq : boardInfoSeq
            }
        });
    },

    getBoardInfosBySearchAndPage(boardCategory, siteInfoSeq, searchInfo, pageNumber) {
        return Send({
            url : `${DEFAULT_API}/getBoardInfosBySearchAndPage?page=${pageNumber}`,
            method : 'GET',
            params : {
                boardCategory : boardCategory,
                siteInfoSeq : siteInfoSeq,
                boardSearchType : searchInfo.boardSearchType,
                searchValue : searchInfo.searchValue
            }
        });
    }
}